import { Injectable } from '@angular/core';
import { Booking } from "../booking/booking.model";

import { JsonApiService } from "../../../core/api/json-api.service";
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { BookingInteraction } from './booking-interaction.model';

import { BookingJourney } from '../bookingJourney/booking-journey.model';

@Injectable()
export class BookingService {

    public data: Subject<any>;

    constructor(private jsonApiService: JsonApiService) {
        this.data = new Subject();
    }

    checkPostCodeExist(booking: Booking): Observable<any> {
        return this.jsonApiService.post('/booking/checkpostcodeexist', booking);
    }

    saveBooking(booking: Booking): Observable<any> {
        return this.jsonApiService.post('/booking/savebooking', booking);
    }

    logBookingInteraction(interaction: BookingInteraction): Observable<any> {
        return this.jsonApiService.post('/booking/LogBookingInteraction', interaction); 
    }

    getaddresses(topCount: number): Observable<any> {
        return this.jsonApiService.fetch('/Booking/addresses?topCount=' + topCount);
    }

    guestQuoteEmail(booking: Booking): Observable<any> {
        return this.jsonApiService.post('/booking/guestquoteemail', booking);
    }

    removeSavedAddress(id: number): Observable<any> {
        return this.jsonApiService.fetch('/Booking/removesavedaddress?bookingId=' + id);
    }

    getDiscountPercent(couponCode: string, bookingDate: string): Observable<any> {
        return this.jsonApiService.fetch('/booking/validatecouponcode?couponCode=' + couponCode + '&bookingDate=' + bookingDate);
    }

    getBookingDetails(bookingId: number): Observable<any> {
        return this.jsonApiService.fetch('/booking/bookingdetails?bookingId=' + bookingId);
    }

    getQuoteDetails(quoteId: number, email: string): Observable<any> {
        return this.jsonApiService.fetch('/booking/quotedetails?quoteId='+quoteId
                                                        + '&emailAddress=' +encodeURIComponent(email));
    }

    saveBookingJourneyStep(bookingJourneyStep: number, note: string) {
        var bookingJourney : BookingJourney = { 
            bookingJourneyStep : bookingJourneyStep, 
            bookingJourneySessionId : 0, 
            note : note
        };
        if (bookingJourneyStep == 1 || bookingJourneyStep == 0) // if its the first step of a journey
        {
            window.localStorage.removeItem('bookingJourneySessionId');
        }
        else
        {
            bookingJourney.bookingJourneySessionId = parseInt(window.localStorage.getItem('bookingJourneySessionId'));
            if (bookingJourney.bookingJourneySessionId == null) {
                bookingJourney.bookingJourneySessionId = 0;
            }
        }

        this.jsonApiService.post('/bookingJourney/SaveBookingJourney', bookingJourney).subscribe(
            (sessionResult: any) => {
                window.localStorage.setItem('bookingJourneySessionId', sessionResult.result);
            },
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/booking/booking.service.ts